import React, { FunctionComponent } from 'react';
import AssetSync, { AssetSyncName } from './asset-sync';
// TODO: use context to keep icons

export type AssetName = AssetSyncName;

export type AssetProps = {
    /**
     * Name of the required asset
     */
    name: AssetName;
    /**
     * SVG preserveAspectRatio attribute
     * @notice be very careful in the usage of this attribute, it may lead to unexpected results, so use it only if 100% needed and you're sure of what you're doing
     */
    preserveAspectRatio?: string;
};

const Asset: FunctionComponent<AssetProps> = ({ name, preserveAspectRatio }) => {
    return <AssetSync name={name} preserveAspectRatio={preserveAspectRatio} />;
};

export default Asset;
